import { render, staticRenderFns } from "./CloseChat.vue?vue&type=template&id=3a898e1a&"
import script from "./CloseChat.vue?vue&type=script&lang=js&"
export * from "./CloseChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports